export default __webpack_public_path__ + "static/media/vera-glass.af8f7817.svg";